import chroma from 'chroma-js';
import moment from 'moment';

const convertJsonToCss = (jsonCss, isMediaQuery = false) => {
  let cssString = "";

  const selectors = Object.keys(jsonCss);
  selectors.forEach(selector => {
    let cssPropertiesString = "";

    if(selector.indexOf('@media') !== -1){
      cssPropertiesString = convertJsonToCss(jsonCss[selector], true)
    }
    else {
      const cssProperties = Object.keys(jsonCss[selector]);

      cssProperties.forEach(cssProperty => {
        cssPropertiesString += `${cssProperty}: ${jsonCss[selector][cssProperty]};`;
      });
    }

    cssString += `\n${isMediaQuery ? '\t' : ''}${selector} {\n\t${isMediaQuery ? '\t' : ''}${cssPropertiesString}\n${isMediaQuery ? '\t' : ''}}\n`
  });

  return cssString;
};

export const applyCssFromJson = (cssJson, styleIdPrefix = 'default', timestamp) => {
  // custom CSS can be included as a json object in the program configs and then will be dynamically added to the DOM. CSS provided in the program configs will be recursively merged with the default configs in the same manner as all other json data. This allows us to override CSS based on program, payment network, currency selector, etc.
  // const {':root': root, ...other} = cssJson;
  // const css = convertJsonToCss({
  //   ':root': generateCssVars(root),
  //   ...other,
  // });
  const css = convertJsonToCss(cssJson);
  const styleNode = document.createElement("style");
  const styleId = `${styleIdPrefix.length ? styleIdPrefix : 'default'}-style-overrides--app-state`;
  const updatedAt = timestamp || moment().format('YYYY-MM-DD-mm.SSS');
  styleNode.id = styleId;
  styleNode.type = 'text/css';
  styleNode.dataset.updatedAt = updatedAt;
  styleNode.appendChild(document.createTextNode(css));
  const previousNode = document.getElementById(styleId);
  if(previousNode){
    document.getElementsByTagName("body")[0].replaceChild(styleNode, previousNode);
  }
  else {
    document.getElementsByTagName("body")[0].appendChild(styleNode);
  }
  return updatedAt;
};

export const removeStyleNodeByDataUpdatedAt = updatedAt => {
  const styleNode = document.body.querySelector(`style[data-updated-at="${updatedAt}"]`);
  if(styleNode) styleNode.remove();
};

export const darken = (color, delta) => {
  try {
    return chroma(color).darken(delta).hex()
  }
  catch(err){
    console.log(err)
  }
};

export const lighten = (color, delta) => {
  try {
    return chroma(color).brighten(delta).hex();
  }
  catch(err){
    console.log(err )
  }
};

export const generateCssVars = (styles = {}) => {
  console.log('old styles', styles)


  const setValue = (key, defaultValue, transformer = val => val) => {
    let val;
    if (styles.hasOwnProperty(defaultValue)){
      val = styles[defaultValue];
    }
    else {
      val = defaultValue;
    }
    // const val = get(styles, defaultValue, defaultValue);
    console.log(key, defaultValue, styles[defaultValue], transformer(val))

    styles[key] = transformer(val);
  };

  const setValues = defaults => {
    defaults.forEach(([key, val, transformer]) => {
      setValue(key, val, transformer);
    });
  };

  setValues([
    ['--default-color', '#b7b7b7'],
    ['--primary-color', '#3f51b5'], // sipree primary
    ['--secondary-color', '#78a22f'], // sipree secondary
    ['--default-bg-color', '--default-color'],
    ['--primary-bg-color', '--primary-color'],
    ['--secondary-bg-color', '--secondary-color'],
    ['--main-bg-color', '#fff'],
    // ['--accent-bg-color', '#f2f8ff'],
    ['--accent-bg-color', '--primary-color', val => lighten(val, 3.4)],
    ['--header-bg-color', '--primary-bg-color'],
    ['--header-font-color', '#fff'],
    ['--header-icon-color', '#fff'],
    ['--footer-bg-color', 'transparent'],
    ['--footer-font-color', '--primary-bg-color'],
    ['--footer-bottom-border-color', '--primary-bg-color'],
    ['--footer-bottom-border-width', '10px'],
    ['--section-title-bg-color', '--primary-bg-color'],
    ['--section-title-font-color', '--header-font-color'],
    ['--section-title-icon-color', '--header-icon-color'],
    ['--modal-overlay-bg-color', '#000000e6'],
    ['--modal-title-bg-color', '--header-bg-color'],
    ['--modal-title-font-color', '--header-font-color'],
    ['--modal-content-bg-color', '--main-bg-color'],
    ['--modal-error-title-bg-color', '--section-title-bg-color'],
    ['--modal-error-title-font-color', '--modal-title-font-color'],
    ['--modal-error-content-bg-color', '--modal-content-bg-color'],
    ['--btn-primary-bg-color', '--primary-bg-color'],
    ['--btn-primary-bg-color-hover', '--btn-primary-bg-color', val => lighten(val, 0.2)],
    ['--btn-primary-font-color', '#fff'],
    ['--btn-primary-font-color-hover', '#fff'],
    ['--btn-primary-box-shadow-active', '2px 2px 2px 0 rgba(4, 31, 91, 0.4)'],
    ['--btn-secondary-bg-color', '--secondary-bg-color'],
    ['--btn-secondary-bg-color-hover', '--btn-secondary-bg-color', val => lighten(val, 1)],
    ['--btn-secondary-font-color', '#fff'],
    ['--btn-secondary-font-color-hover', '#fff'],
    ['--btn-secondary-box-shadow-active', '2px 2px 2px 0 rgba(4, 31, 91, 0.4)'],
    ['--payment-amount-font-color', '#000'],
    ['--payment-amount-font-weight', 'bold'],
    ['--payment-currency-font-color', '#000'],
    ['--payment-currency-font-weight', 'bold'],
    ['--payment-paymentNetwork-font-color', '#000'],
    ['--payment-paymentNetwork-font-weight', 'bold'],
    ['--payment-updateAt-font-color', '#000'],
    ['--payment-updatedAt-font-weight', 'bold'],
  ]);

  console.log('new styles', styles)
  return styles
};

export const generateTheme = colors => {
  const styles = [];

  Object.keys(colors).map(key => ({type: key, color: colors[key]})).forEach(({type, color}) => {
    styles.push([`--${type}-color`, color]);
    styles.push([`--${type}-bg-color`, color]);

    if(type === 'primary'){
      styles.push([]);
      styles.push(['--header-bg-color', color]);
      styles.push([]);
      styles.push(['--footer-font-color', color]);
      styles.push(['--footer-bottom-border-color', color]);
      styles.push([]);
      styles.push(['--section-title-bg-color', lighten(color, 0.5)]);
      styles.push([]);
      styles.push(['--modal-title-bg-color', color]);
      styles.push(['--modal-error-title-bg-color', color]);
      styles.push([]);
    }

    styles.push([`--btn-${type}-bg-color`, color]);
    styles.push([`--btn-${type}-bg-color-hover`, lighten(color, 0.5)]);
  });

  let cssString = `"css": {\n\t":root": {\n`;
  styles.forEach((style, idx, arr) => {
    if(!style.length) cssString += '\n';
    else {
      const [selector, rule] = style;
      cssString += `\t\t"${selector}": "${rule}"${idx !== arr.length - 1 ? ',' : ''}\n`;
    }
  });
  cssString += '\t}\n}';
  return cssString;
};

export const loadExternalCSS = (css, styleIdPrefix = 'default') => {
  const styleNode = document.createElement("style");
  const styleId = `${styleIdPrefix}-style-overrides--program-config`;
  styleNode.id = styleId;
  styleNode.type = 'text/css';
  styleNode.dataset.updatedAt = moment().format('YYYY-MM-DD-LTS');
  styleNode.appendChild(document.createTextNode(css));
  const previousNode = document.getElementById(styleId);
  if(previousNode){
    document.getElementsByTagName("body")[0].replaceChild(styleNode, previousNode);
  }
  else {
    document.getElementsByTagName("body")[0].appendChild(styleNode);
  }
};

export const getStyleIdPrefixFromProgramName = (programName = 'unspecified-program') => programName.toLowerCase().replace(/\s/, '_');


// console.log(generateTheme({primary: '#041f5b'}))
